import { Injectable } from '@angular/core';
import { DataService } from '../../../shared/services/data.service';
import { StorageService } from '../../../shared/services/storage.service';
import { ResponseModel } from '../../../shared/models/response-model.model';
import { tap } from 'rxjs';
import { CustomerDetailsModel } from './customer-details.model';


@Injectable({
  providedIn: 'root'
})
export class CustomerDetailsService {

  constructor(public service: DataService,public storageService: StorageService) {}

  getCustomerDetailsById(data:any){
    let url = `api/App/Customer/getCustomerById?Id=${data}`;
    return this.service.get(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );  
  }

  insertCustomerDetails(data: CustomerDetailsModel) {
    let url = `api/App/Customer/insertCustomerDetails`;
    return this.service.post(url, data).pipe<ResponseModel>(tap((response: any) => {
      return response;
    })
    );
  }

  updateCustomerDetails(data:CustomerDetailsModel){
    let url = `api/App/Customer/updateCustomerDetails`;
    return this.service.post(url,data).pipe<ResponseModel>(tap((response: any) => {
    return response;
      })
    );  
  }
}
